import { domain as infoDomain } from "./info.js"

const info = infoDomain.selector

export const selectors = { info }
